@if (hasChanges() || busy()) {
  <div class="save-overlay-wrapper" [class.shaking]="shaking()" @saveOverlay>
    <div class="save-overlay">
      <span>{{ 'ct-library.form-saver.primary' | transloco }}</span>
      <div class="save-overlay-buttons">
        <button
          type="button"
          class="ct-btn ct-btn-white-grey"
          [disabled]="busy()"
          (click)="discard()"
        >
          {{ 'ct-library.form-saver.discard-button' | transloco }}
        </button>
        <button
          type="button"
          class="ct-btn ct-btn-primary"
          [disabled]="busy()"
          [attr.aria-busy]="busy() ? true : null"
          (click)="save()"
        >
          {{ 'ct-library.form-saver.save-button' | transloco }}
          @if (busy()) {
            <ct-lib-spinner [size]="18"></ct-lib-spinner>
          }
        </button>
      </div>
    </div>
  </div>
}
